import React, { useState } from "react";
import "./envelope.css";

import TopFlap from "./Topflap";
import BottomFlap from "./BottomFlap";
import LeftFlap from "./LeftFlap";
import RightFlap from "./RightFlap";
import { NavLink } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { ReactComponent as GanpatiIcon } from "../../../../../images/ganpati2.svg";
import { ReactComponent as OmIcon } from '../../../../../images/om.svg';
import { ReactComponent as EkOnkarIcon } from '../../../../../images/ekonkar.svg';
import { ReactComponent as KhandaIcon } from '../../../../../images/khanda.svg';
import { ReactComponent as CrossIcon } from '../../../../../images/cross.svg';
import { ReactComponent as BismillahIcon } from '../../../../../images/bismillah.svg';
import { ReactComponent as WaipIcon } from '../../../../../images/waip.svg';
import { ReactComponent as RingsIcon } from '../../../../../images/rings.svg';
import { ReactComponent as KnotIcon } from '../../../../../images/knot.svg';
import { ReactComponent as SwastikIcon } from '../../../../../images/swastik.svg';
import { ReactComponent as BuddhaIcon } from '../../../../../images/buddha.svg';
const Envelope = ({ SetEnvelopeScreen,details ,demoExpired,onOpen}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isVisible, setIsVisible] = useState(true);


  const handleSealClick = () => {
    if (isAnimating) return;

    setIsAnimating(true);

      if (onOpen) {
    onOpen();
  }
  

    setTimeout(() => {
      setIsVisible(false);
      SetEnvelopeScreen(false)
    }, 1350);
  };

  if (!isVisible) return null;

  const iconMapping = {
      EkOnkarIcon,
      GanpatiIcon,
      OmIcon,
      KhandaIcon,
      CrossIcon,
      BismillahIcon,
      WaipIcon,
      RingsIcon,
      KnotIcon,
      SwastikIcon,
      BuddhaIcon,
  };


   const stampImage = {
  theme1:
    "/stamp.png",

  theme2:
    "/theme2-stamp.png",

  // Add more themes here
  theme3:
    "/theme3-stamp.png",

  theme4:
    "/theme-4-stamp.png",

    theme5:
    '/theme3-stamp.png'
};

const defaultStamp =
  "/stamp.png";

    const SealImage =
    stampImage[details?.theme] || defaultStamp;
  

 const Icon = ({ className }) => {
        const Component = iconMapping[details && details.coverIcon];

        if (!Component) return null;

        return <Component className={className} />;
    };

  return (
    <>
    <div className={`envelope-screen ${details?.theme || ''}`}>

      <div className={`envelope ${isAnimating ? "animate" : ""}`}>
       <div className="envelope-seal">
        <img
          src={SealImage}
          alt="Seal"
          onClick={handleSealClick}
        />
        </div>
         <div className="top-area">
            <div className="top-area-content">
             <Icon className="top-area-icon" />
          <span>{details && details.coverText}</span>
        </div>
         </div>
      
<div className="click-to-open">
  Click to open
</div>

<div className="bottom-area-content">

  <span className="bottom-title">
    {details && details.withRegardsTitle}
  </span>

  <span className="bottom-name">
  {details && details.withRegards}
  </span>

</div>
        <TopFlap />
        <BottomFlap />
        <LeftFlap />
        <RightFlap />

      </div>

    </div>
   {demoExpired && (
             <div className="demo-expired-modal-overlay">
                 <div className="demo-expired-modal" >
                    <h2>
                 <span role="img" aria-label="lock">🔒</span> Invite Access Paused
   
               </h2>
                 <p className="demo-expired-subtext-1">This invite is currently locked. Please ask the host to unlock it.</p>
                  {/* <p className="demo-expired-subtext-2">( Hurry Up! Invite Expires Soon )</p> */}
                   <NavLink to="/" className="demo-expired-btn">
                             Unlock Invite <ArrowForwardIcon style={{marginLeft:"5px",transform: "translateY(-1px)" }}/>
                           </NavLink>
                 </div>
             </div>
   )}
    </>
  );
};

export default Envelope;